import { render, staticRenderFns } from "./TetraNews.vue?vue&type=template&id=934adb44&scoped=true"
import script from "./TetraNews.vue?vue&type=script&lang=js"
export * from "./TetraNews.vue?vue&type=script&lang=js"
import style0 from "./TetraNews.vue?vue&type=style&index=0&id=934adb44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934adb44",
  null
  
)

export default component.exports